import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import AuthCallback from "@/pages/AuthCallback";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import AuthPage from "@/pages/AuthPage";
import ForgotPage from "@/pages/ForgotPage";
import ResetPage from "@/pages/ResetPage";
import Studio from "@/pages/Studio";
import Landing from "@/pages/Landing";
import AdminPage from "@/pages/AdminPage";
import { ChatBubble } from "@/components/ChatBubble";

const Loading = () => (
  <div className="min-h-screen grid place-items-center" data-testid="app-loading">
    <span className="rf-mono text-xs tracking-[0.3em] uppercase">Caricamento</span>
  </div>
);

const PublicOnly = ({ children }) => {
  const { user } = useAuth();
  if (user === null) return <Loading />;
  return user ? <Navigate to="/" replace /> : children;
};

const Home = () => {
  const { user } = useAuth();
  if (user === null) return <Loading />;
  return user ? <><Studio />{user.role !== "admin" && <ChatBubble />}</> : <Landing />;
};

const AdminOnly = () => {
  const { user } = useAuth();
  if (user === null) return <Loading />;
  if (!user) return <Navigate to="/login" replace />;
  return user.role === "admin" ? <AdminPage /> : <Navigate to="/" replace />;
};

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/admin" element={<AdminOnly />} />
      <Route path="/login" element={<PublicOnly><AuthPage /></PublicOnly>} />
      <Route path="/forgot-password" element={<ForgotPage />} />
      <Route path="/reset-password" element={<ResetPage />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRouter />
      </BrowserRouter>
      <Toaster position="bottom-left" />
    </AuthProvider>
  );
}

export default App;
